export function stringIsNullOrWhitespace(string?: string): boolean {
  return string === undefined || string === null || string === ''
}